import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/auth";

export default function Achievements() {
 const [rows, setRows] = useState([]);
 useEffect(() => { axios.get(`${API}/users/me/achievements`).then(r => setRows(r.data)).catch(() => {}); }, []);
 const unlocked = rows.filter(r => r.unlocked).length;
 return (
 <div className="bg-yt-surface border border-yt-border p-6 mb-8">
 <div className="flex items-center justify-between mb-4">
 <div>
 <div className="font-mono text-[10px] tracking-[0.3em] text-yt-muted">ACHIEVEMENTS</div>
 <div className="font-display text-2xl tracking-tight">UNLOCKED · <span className="text-yt-yellow">{unlocked}</span>/{rows.length}</div>
 </div>
 </div>
 <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
 {rows.map(a => (
 <div key={a.key} data-testid={`achievement-${a.key}`}
 className={`text-center p-3 border ${a.unlocked ? "border-yt-yellow bg-yt-yellow/10" : "border-yt-border bg-black opacity-40"}`}
 title={a.blurb}>
 <div className="text-3xl mb-1 grayscale-0" style={{ filter: a.unlocked ? "none" : "grayscale(1)" }}>{a.icon}</div>
 <div className="font-display text-xs tracking-tight">{a.name}</div>
 <div className="font-mono text-[9px] text-yt-muted leading-tight mt-1 line-clamp-2">{a.blurb}</div>
 </div>
 ))}
 </div>
 </div>
 );
}
